import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { ILpActivity } from '@gametailors/leerplus';
import { delay } from '@gametailors/web-core/misc';
import { LpRidShowRewardActivity } from '../../../../typings/schema';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidAssignmentBackground } from '../../components/rid-assignment-background/rid-assignment-background';
import { LEERPLUS } from '../../rid-game.utils';
import { RidRewardService } from '../../services/rid-reward.service';

const REWARD_DELAY_MS = 500;
const BUTTON_DELAY_MS = 1000;

@Component({
  selector: 'rid-show-reward-activity',
  imports: [RidAssignmentBackground, RidButton],
  templateUrl: './rid-show-reward-activity.html',
})
export class RidShowRewardActivity implements ILpActivity<LpRidShowRewardActivity>, OnInit {
  protected readonly $lpApiService = inject(LEERPLUS.apiToken);
  private readonly rewardService = inject(RidRewardService);

  activity = input.required<LpRidShowRewardActivity>();

  protected readonly reward = computed(() => this.rewardService.resolveReward(this.activity().reward));

  protected readonly showReward = signal(false);
  protected readonly showButton = signal(false);

  async ngOnInit(): Promise<void> {
    await delay(REWARD_DELAY_MS);
    this.showReward.set(true);
    await delay(BUTTON_DELAY_MS);
    this.showButton.set(true);
  }

  placeInBook() {
    this.$lpApiService.finishCurrentActivity();
  }
}
